// src/components/molecules/PluxButton.tsx
import { memo, useEffect } from "react";
import { createPortal } from "react-dom";
import type { CSSProperties } from "react";
import type { PluxData } from "../../config/plux.data";

declare const Data:
  | { init: (d: unknown) => void; reload: (d: unknown) => void; $onAuthorize?: unknown }
  | undefined;

const estiloBoton: CSSProperties = {
  backgroundColor: "#6C2BD9",
  backgroundImage: "url(https://paybox.pagoplux.com/img/pagar.png?v1)",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  backgroundSize: "contain",
  height: 72,
  width: 215,
  border: "none",
  cursor: "pointer",
  outline: 0,
  boxShadow: "0px 2px 2px lightgray",
};

// memo: el modal de checkout tiene un contador que re-renderiza cada segundo.
// Sin memo, React reconciliaría <div id="modalPaybox"> (vacío en su árbol) y
// BORRARÍA el modal/#iframePaybox que el SDK de Plux inyecta ahí por jQuery —
// entonces execute() (al click) no encuentra #iframePaybox y el popup no abre.
// El prop `data` es estable (viene de estado), así que memo evita ese re-render.
export const PluxButton = memo(function PluxButton({ data }: { data: PluxData }) {
  useEffect(() => {
    if (typeof Data !== "undefined" && Data) {
      // El SDK global de Plux solo extrae `onAuthorize` de los datos la PRIMERA vez que
      // inicializa (guard interno `if ($onAuthorize == undefined)`). En una SPA `Data`
      // persiste y `init` corre varias veces → la 2ª deja la función dentro de `$data` y,
      // al hacer postMessage al iframe, lanza DataCloneError (las funciones no se clonan)
      // → el popup nunca abre. Reseteamos `$onAuthorize` para forzar la extracción cada
      // vez, y pasamos una COPIA para no mutar nuestro `data` estable (el SDK hace delete).
      Data.$onAuthorize = undefined;
      Data.init({ ...data });
    }
  }, [data]);
  return (
    <>
      {/* Portal a <body>: el SDK de Plux inyecta aquí un modal position:fixed
          z-index:999999. Si #modalPaybox vive dentro del modal de React (con su
          overflow/stacking), el fixed queda atrapado y el popup no se ve. En el
          body escapa al viewport y tapa todo. El botón #pay sí queda en el checkout. */}
      {createPortal(<div id="modalPaybox" />, document.body)}
      <button style={estiloBoton} id="pay" type="button" aria-label="Pagar con Plux" />
    </>
  );
});
